(function () {
  'use strict';

  /* @ngdoc object
   * @name components
   * @description
   *
   */
  angular
  .module('neo.components', []);
}());
